import { GaussianViewer, type GaussianViewerProps } from "./GaussianViewer";
export function PLYViewer(props: GaussianViewerProps) {
	return <GaussianViewer format="ply" {...props} />;
}
